import { useAppSelector } from "@/redux/hooks";
import { authSelectors } from "@/redux/slices/auth.slice";

/**
 * Hook para verificar se o usuário tem permissão para funcionalidades administrativas de oração
 * (acessar listagem de pedidos de oração, gerenciar marcadores, etc.)
 * @returns {boolean} - true se o usuário é master ou tem permissão ORACAO
 */
export function useOracaoPermission(): boolean {
  const user = useAppSelector((state) => state.authReducer);
  const selectedOrg = useAppSelector(authSelectors.Login);

  // Se não há usuário ou organização selecionada, não tem permissão
  if (!user || !selectedOrg) {
    return false;
  }

  // Usuários master sempre têm permissão
  if (user.Master) {
    return true;
  }

  // Verificar se o usuário tem permissão específica para ORACAO
  const hasOracaoPermission = user.usuarioLogins?.some((userLogin) => {
    return (
      userLogin.tipoPermissao === "ORACAO" &&
      userLogin.logins?.Id === selectedOrg.Id
    );
  });

  return hasOracaoPermission || false;
}
